import { useT } from '../../i18n';
import { useViewportKind } from '../useViewport';
import { Message, Notes, PeriodPills, ReportPage } from './ReportParts';
import { periodBody } from './reportsApi';
import { supplierName } from './reportFormat';
import { useReportPeriod } from './periodStore';
import { useReport } from './useReport';
import { DocumentsCard, MoneyPair, ProblemsCard, RankingTable } from './WhoParts';

const KINDS = ['this_week', 'this_month', 'this_year', 'custom'];

// Leo's "Report: suppliers" (updated board): Orders and Invoiced, then Documents per type next to Discrepancies identified (Documents late and Price increases apart, not in the total),
// then the suppliers ranked by order value with Orders, Order value, Invoiced and Commission; every row opens the supplier page.
export default function SuppliersView() {
  const t = useT();
  const phone = useViewportKind() === 'phone';
  const [period, setPeriod] = useReportPeriod('past');
  const { status, data, retry } = useReport('suppliers', periodBody(period));
  const two = { display: 'grid', gridTemplateColumns: phone ? '1fr' : 'repeat(2, minmax(0, 1fr))', gap: 18 };
  return (
    <ReportPage title={t('reports.suppliers.title')} backTo="/reports" pills={<PeriodPills kinds={KINDS} value={period} onChange={setPeriod} />} testid="report-suppliers">
      {status !== 'ready' ? <Message status={status} onRetry={retry} /> : (
        <>
          <MoneyPair data={data} prefix="sup" phone={phone} />
          <div style={two}>
            <DocumentsCard documents={data.documents} prefix="sup" />
            <ProblemsCard problems={data.problems} currency={data.currency} prefix="sup" who="supplier" />
          </div>
          <RankingTable title={t('reports.suppliers.ranking')} testid="sup-ranking" currency={data.currency}
            columns={[{ key: 'orders', label: t('reports.who.col.orders') }, { key: 'order_value', label: t('reports.who.col.orderValue'), money: true }, { key: 'invoiced', label: t('reports.who.col.invoiced'), money: true, strong: true }, { key: 'commission', label: t('reports.col.commission'), money: true, green: true }]}
            rows={data.ranking.map((r, i) => ({ id: r.supplier ? r.supplier.id : `none-${i}`, testid: r.supplier ? `sup-row-${r.supplier.id}` : 'sup-row-none', name: supplierName(r.supplier, t), to: r.supplier && !r.supplier.unknown ? `/reports/suppliers/${r.supplier.id}` : null, bar: r.bar, orders: r.orders, order_value: r.order_value, invoiced: r.invoiced, commission: r.commission }))} />
          <Notes notes={data.notes} />
        </>
      )}
    </ReportPage>
  );
}
